import { spaceFileActorSchema, spaceFileEntryIdSchema } from "./space-files.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-file-update-settings.ts
const spaceFileUpdateSettingsSchema = z$1.strictObject({
	fileId: spaceFileEntryIdSchema,
	version: z$1.number().int().nonnegative(),
	recipientProfileIds: z$1.array(z$1.string().trim().min(1)).max(50),
	configuredBy: spaceFileActorSchema.nullable()
});
const spaceFileUpdateSettingsCommandSchema = z$1.discriminatedUnion("action", [z$1.strictObject({ action: z$1.literal("read") }), z$1.strictObject({
	action: z$1.literal("configure"),
	baseVersion: z$1.number().int().nonnegative(),
	recipientProfileIds: z$1.array(z$1.string().trim().min(1)).max(50)
})]);
//#endregion
export { spaceFileUpdateSettingsCommandSchema, spaceFileUpdateSettingsSchema };

//# sourceMappingURL=space-file-update-settings.js.map